"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const logo_360_oficial_webp_1 = __importDefault(require("../../../assets/images/logo_360_oficial.webp"));
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
require("./AccessWrapper.scss");
const AccessWrapper = (0, react_1.forwardRef)(({ showTerms = true, children }, ref) => {
    const [isModalTermsVisible, setIsModalTermsVisible] = (0, react_1.useState)(false);
    const location = (0, react_router_dom_1.useLocation)();
    const modalVisible = (0, react_1.useCallback)(() => {
        setIsModalTermsVisible(!isModalTermsVisible);
    }, [isModalTermsVisible]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        modalVisible,
    }));
    return (react_1.default.createElement("div", { className: "AccessWrapper" },
        react_1.default.createElement("img", { className: "logo", src: logo_360_oficial_webp_1.default, alt: "" }),
        react_1.default.createElement("div", { className: "content-container" }, children),
        showTerms && (react_1.default.createElement("div", { className: "access-footer" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null,
                    "Copyright \u00A9",
                    new Date().getFullYear(),
                    ".")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_router_dom_1.Link, { className: "policy", to: {
                        pathname: RoutesPaths_1.routesPaths.privacy,
                        state: { from: location.pathname },
                    } }, "Pol\u00EDtica de privacidade"),
                "\u00A0",
                react_1.default.createElement(react_router_dom_1.Link, { className: "policy", to: {
                        pathname: RoutesPaths_1.routesPaths.cancel,
                        state: { from: location.pathname },
                    } }, "Pol\u00EDtica de Cancelamento"),
                "\u00A0",
                react_1.default.createElement(react_router_dom_1.Link, { className: "policy", to: {
                        pathname: RoutesPaths_1.routesPaths.terms,
                        state: { from: location.pathname },
                    } }, "Termos de uso"))))));
});
exports.default = AccessWrapper;
